import { render, staticRenderFns } from "./NormalSearchNav153.vue?vue&type=template&id=27dd9ec8&scoped=true&"
import script from "./NormalSearchNav153.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav153.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd9ec8",
  null
  
)

export default component.exports